var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u570B\\u6CF0\\u4ED8\\u6B3E\\u8A2D\\u5B9A\\uFF08\\u901A\\u8DEF\\u885D\\u7A81\\uFF09",
    transform: "translate(-290.000000, -542.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(292.000000, 544.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,28 C56,43.4639192 43.4639192,56 28,56 C12.5360808,56 0,43.4639192 0,28 C0,12.5360808 12.5360808,0 28,0 C43.4639192,0 56,12.5360808 56,28 Z",
    id: "Stroke-1",
    stroke: "#2A3238",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8393594,36.9000278 C25.8393594,35.6695079 26.7171423,34.7383651 27.9833816,34.7383651 C29.2131361,34.7383651 30.1263308,35.6695079 30.1263308,36.9000278 L30.1263308,38.6518966 C30.1263308,39.8448521 29.2131361,40.8135593 27.9833816,40.8135593 C26.7171423,40.8135593 25.8393594,39.8448521 25.8393594,38.6518966 L25.8393594,36.9000278 Z M25.6279618,16.8087447 C25.5936231,15.4302436 26.61198,14.2372881 27.9833816,14.2372881 C29.2828866,14.2372881 30.4074788,15.4302436 30.372067,16.8087447 L30.0555072,29.7809975 C29.950345,31.0103792 29.1069008,31.9050958 27.9468968,31.9050958 C26.7879658,31.9050958 25.9445216,30.9728147 25.9091099,29.7809975 L25.6279618,16.8087447 Z",
    id: "Fill-3",
    fill: "#000000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.e94021018e75ce2b0820214d986b6dba.svg";
export { ForwardRef as ReactComponent };